import { SIMAElementClassifier } from "../types";
/**
 * 測量座標点 (A01 要素)。
 * モデル内ではキャメルケース (pointNumber, pointName) を使用し、
 * ワイヤフォーマット (ISIMASurveyCoord) への変換は toCoord() で行います。
 */
export class SurveyPoint {
    classifier = SIMAElementClassifier.SURVEY_POINT_COORD;
    pointNumber;
    pointName;
    x;
    y;
    z;
    constructor(data) {
        this.pointNumber = data.pointNumber ?? data.point_number ?? 0;
        this.pointName = data.pointName ?? data.point_name ?? "";
        this.x = data.x ?? 0;
        this.y = data.y ?? 0;
        this.z = data.z ?? 0;
    }
    get point_number() {
        return this.pointNumber;
    }
    set point_number(val) {
        this.pointNumber = val;
    }
    get point_name() {
        return this.pointName;
    }
    set point_name(val) {
        this.pointName = val;
    }
    /**
     * ワイヤフォーマット (A01 レコード形状) に変換します。
     */
    toCoord() {
        return {
            classifier: SIMAElementClassifier.SURVEY_POINT_COORD,
            point_number: this.pointNumber,
            point_name: this.pointName,
            x: this.x,
            y: this.y,
            z: this.z,
        };
    }
}
//# sourceMappingURL=survey-point.js.map